module.exports = __webpack_public_path__ + "img/project-cargo.9aa90c52.jpg";